import {Link} from "react-router-dom";
import ContactStillNeedHelpComponent from "../../components/contact/ContactStillNeedHelpComponent.tsx";
import ContactPageLayout from "./ContactPageLayout.tsx";

export default function ContactDeliveryTime() {
    return (
        <ContactPageLayout
            meta_title={"Leveringstid på internet"}
            meta_description={"Internettets leveringstid afhænger bl.a. produktvalg, om installation på din adresse er klar til brug, og om der skal graves fiberkabler ned på din grund."}
            title={"Leveringstid"}
            className={"page-contact-delivery-time"}
            content={
                <>
                    <section className="contact-content">
                        <p>Leveringstiden afhænger af flere elementer, såsom hvilket produkt du har bestilt, om installationen på din adresse er klar til brug, og om der skal graves fiberkabler ned på din grund.</p>
                        <p>Har du bestilt et bi-produkt som en fast IP-adresse, kan det tage helt ned til 10 min. før den træder i kraft.</p>
                        <p>Læs mere om leveringstiden på internet blandt vores tre internet-teknologier her:</p>
                        <Link to={'/hjaelp/bestilling/leveringstid'} className={'button button--montserrat teal'}>Leveringstid på internet</Link>
                    </section>

                    <ContactStillNeedHelpComponent phone={true} form={true}/>
                </>
            }
        />
    )
}
